import colors from './colors'

export type coreColorsType = keyof typeof colors

export default colors
